import theme from 'tailwind.theme';

export const chartColours = [
  theme.colors.secondary[200],
  theme.colors.primary[700],
  theme.colors.success[400],
  theme.colors.primary[500],
  theme.colors.primary[300],
  theme.colors.error[300],
  theme.colors.success[200],
  theme.colors.primary[100],
  theme.colors.primary[50]
];
